import React from "react";
import { Link } from "react-router-dom";

import Particles from "./../Particles/particles";
const navigation = [
  { name: "About", href: "/about", id: 1 },
  { name: "Projects", href: "/projects", id: 2 },
  { name: "Contact", href: "/contact", id: 3 },
];

export default function Home() {
  return (
    <div className="flex flex-col items-center justify-center w-screen h-screen overflow-hidden bg-gradient-to-tl from-black via-zinc-600/10 to-black">
      <nav className="my-16 animate-fade-in">
        <ul className="flex items-center justify-center gap-4">
          {navigation.map((item) => (
            <Link
              key={item.id}
              to={item.href}
              className="text-sm duration-500 text-zinc-500 hover:text-zinc-300"
            >
              {item.name}
            </Link>
          ))}
        </ul>
      </nav>
      <div className="hidden w-screen h-px animate-glow sm:block animate-fade-left bg-gradient-to-r from-zinc-300/0 via-zinc-300/50 to-zinc-300/0" />
      <Particles
        className="absolute inset-0 -z-10 animate-fade-in"
        quantity={100}
      />
      <h1 className="z-10 text-4xl text-transparent duration-1000 bg-white cursor-default text-edge-outline animate-title font-display sm:text-6xl md:text-8xl whitespace-nowrap bg-clip-text ">
        Abdallah Noor
      </h1>

      <div className="hidden w-screen h-px animate-glow sm:block animate-fade-right bg-gradient-to-r from-zinc-300/0 via-zinc-300/50 to-zinc-300/0" />
      <div className="my-16 text-center animate-fade-in">
        <h2 className="text-sm text-zinc-500 p-2">
          I'm building the Frontend of Websites and Web Applications that leads
          to the success of the overall product.
        </h2>
      </div>
    </div>
  );
}
// git commit -m "first commit"
// git branch -M main
// git remote add origin https://github.com/abdallanoor/portfolio.git
// git push -u origin main
//   <div className="flex flex-col items-center justify-center w-screen h-screen overflow-hidden bg-gradient-to-tl from-black via-zinc-600/10 to-black">
//   <nav className="my-16 animate-fade-in">
//     <ul className="flex items-center justify-center gap-4">
//       {navigation.map((item) => (
//         <Link
//           key={item.id}
//           to={item.href}
//           className="text-sm duration-500 text-zinc-500 hover:text-zinc-300"
//         >
//           {item.name}
//         </Link>
//       ))}
//     </ul>
//   </nav>
//   <div className="hidden w-screen h-px animate-glow md:block animate-fade-left bg-gradient-to-r from-zinc-300/0 via-zinc-300/50 to-zinc-300/0" />
//   <Particles
//     className="absolute inset-0 -z-10 animate-fade-in"
//     quantity={100}
//   />
//   <h1 className="z-10 text-4xl text-transparent duration-1000 bg-white cursor-default text-edge-outline animate-title font-display sm:text-6xl md:text-9xl whitespace-nowrap bg-clip-text ">
//     Abdallah
//   </h1>

//   <div className="hidden w-screen h-px animate-glow md:block animate-fade-right bg-gradient-to-r from-zinc-300/0 via-zinc-300/50 to-zinc-300/0" />
//   <div className="my-16 text-center animate-fade-in">
//     <h2 className="text-sm text-zinc-500 p-2">
//       I'm building the Frontend of Websites and Web Applications that leads
//       to the success of the overall product.
//     </h2>
//   </div>
// </div>
